import React from 'react';
import { 
  Routes as RouterRoutes, 
  Route, 
  Navigate 
} from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import AuthPage from '../components/auth/AuthPage';
import AuthCallback from '../components/auth/AuthCallback';
import UserProfile from '../components/auth/UserProfile';
import MainApp from '../components/MainApp';
import UsersManagement from '../components/users/UsersManagement';

/**
 * Configuration des routes de l'application
 * - Routes publiques : login, register, forgot-password, reset-password
 * - Routes protégées : toutes les autres routes nécessitant une authentification
 */
const AppRoutes: React.FC = () => {
  return (
    <RouterRoutes>
      {/* Routes publiques */}
      <Route path="/login" element={<AuthPage />} />
      <Route path="/register" element={<AuthPage />} />
      <Route path="/forgot-password" element={<AuthPage />} />
      <Route path="/reset-password" element={<AuthPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      {/* Routes protégées */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<MainApp />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/users" element={<UsersManagement />} />
      </Route>
      
      {/* Redirection par défaut */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </RouterRoutes>
  );
};

export default AppRoutes;

